import {
  union as unionApi,
  diff as diffApi,
  intersection as intersectionApi
} from 'local-martinez-polygon-clipping'; // TODO - delete "local-" at beginning to import external package. Must be done after main distribution includes needed changes.

import { guardedCall } from './guarded-call';
import { coordinatesToXPolygon } from 'geometry/geojson/convert';
import { isValidXPolygon } from 'geometry/geojson/validator';
import { clippingLibrary } from 'geometry/geojson/constants';

const library = clippingLibrary.MARTINEZ;

/* Use calculateOverlap() instead of intersection(), calculateUnion() instead of union(), calculateDifference()
   instead of diff(). You will be insulated from known issues and upcoming changes to 3rd-party libraries. */

const coordinatesResultValidator = (coords) => {
  if (!coords || !coords.length) { return; }
  const xPolygon = coordinatesToXPolygon(coords);
  const failures = [];
  if (!isValidXPolygon(xPolygon, failures))
  { throw new Error(`bad xPolygon returned from API: ${failures.join('\n')}`); }
};

// Add wrappers below as needed.
export function diff() {
  return guardedCall({func:diffApi, args:[...arguments], library, funcName:'diff',
    onValidateResult:coordinatesResultValidator });
}
export function intersection() {
  return guardedCall({func:intersectionApi, args:[...arguments], library,
    funcName:'intersection', onValidateResult:coordinatesResultValidator });
}
export function union() {
  return guardedCall({func:unionApi, args:[...arguments], library, funcName:'union',
    onValidateResult:coordinatesResultValidator });
}
